'use client';

import { GridItem } from '@hrworks/sui-core/GridItem';

import { S } from '../Layout.styles';
import type { LayoutMainProps } from './LayoutMain.types';

export const LayoutMain = ({ rowGap, hasSidebar, children, ...otherProps }: LayoutMainProps) => (
  <GridItem size={hasSidebar ? { xs: 12, lg: 8, xl: 7 } : { xs: 12, xl: 10 }} offset={{ xs: 0, xl: 1 }} {...otherProps}>
    <S.ColumnLayout as="main" rowGap={rowGap}>
      {children}
    </S.ColumnLayout>
  </GridItem>
);
